// Newsletter DEMO form validator (client-side only — rendered until a real
// Contact Form 7 shortcode is set in the Customizer). Same behavior as the
// prototype: an invalid address shows a toast and refocuses the field; a
// valid one swaps the form for a confirmation. No email is sent.
// Exposed as wpsInitNewsletter(scope) because the form can arrive via a
// barba page transition; each form is bound once.
(function () {
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init(scope) {
    (scope || document).querySelectorAll(".js-newsletter-form").forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = "1";

      var input = form.querySelector('input[type="email"]');
      var msg = form.querySelector("[data-newsletter-msg]");
      if (!input) return;

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        form.classList.remove("is-success", "is-error");

        if (!emailPattern.test(input.value.trim())) {
          var error = "Enter a valid email to subscribe";
          form.classList.add("is-error");
          input.setAttribute("aria-invalid", "true");
          if (msg) msg.textContent = error;
          if (window.wpsToast) window.wpsToast((window.wpsData && window.wpsData.i18n.validEmail) || error);
          input.focus();
          return;
        }

        // FAKE send: a short "sending" state, then the success message from the
        // Customizer. Nothing leaves the browser until a real CF7 form is set.
        input.removeAttribute("aria-invalid");
        var button = form.querySelector('button[type="submit"]');
        var label = button ? button.textContent : "";
        form.classList.add("is-sending");
        input.readOnly = true;
        if (button) {
          button.disabled = true;
          button.setAttribute("aria-busy", "true");
          button.textContent = form.dataset.sending || "Sending…";
        }
        setTimeout(function () {
          form.classList.remove("is-sending");
          form.classList.add("is-success");
          input.readOnly = false;
          if (button) {
            button.disabled = false;
            button.removeAttribute("aria-busy");
            button.textContent = label;
          }
          form.reset();
          if (msg) msg.textContent = form.dataset.success || "You're on the list — check your inbox to confirm.";
        }, 1100);
      });
    });
  }

  window.wpsInitNewsletter = init;
  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });
})();
